import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/Label.tsx